import { render, staticRenderFns } from "./LinkDeviationCrewTable.vue?vue&type=template&id=3a4d7a74"
import script from "./LinkDeviationCrewTable.vue?vue&type=script&lang=js"
export * from "./LinkDeviationCrewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports